// input 元素上直接加 v-limitNum 针对inut元素或元素里面有子元素input的元素
export default function(el) {
  var input = el;
  if (input.value === undefined) input = el.getElementsByTagName('input')[0]
  input.onkeyup = function(e) {
    if (input.value === '') return
    if (input.value.length == 1) {
      input.value = input.value.replace(/[^1-9]/g, '');
    } else {
      input.value = input.value.replace(/[^\d]/g, '');
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/directive/onlyNum.js